import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../../redux/actions";

import * as THREE from "three";
import Stats from 'three/examples/jsm/libs/stats.module.js';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { SMAAPass } from 'three/examples/jsm/postprocessing/SMAAPass.js';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader.js';
import hdrBKD from "../../assets/apple_1k.hdr";
// import hdrENV from "../../assets/autoshop_1k.hdr";
import hdrENV from "../../assets/photo_studio_01_1k.hdr";


class Shade extends Component {

    componentDidMount() {
        // this.startStats();
        this.startScene();
        this.startLights();
        // this.startRefGeo();
        this.startCamera();
        this.startControls();
        this.startRenderer();
        this.startEnvironment();
        this.startLoader();
      };

    updateResizeHandler = () => {
      this.updateResizeAlarm = 4;
    };

    startStats = () => {
      this.stats = new Stats();
      this.mount.appendChild( this.stats.dom );
    };

    startScene = () => {
      this.scene = new THREE.Scene();
      //ALL UPDATE ALARMS GO HERE
      this.updateResizeAlarm = 0;
    };

    startLights = () => {
      const { lightingScenario} = this.props.engine;

      if (lightingScenario === 1) {
        var standaLight = [];
        standaLight[0] = new THREE.PointLight(0xffd6d6,1300,200,2);
        standaLight[1] = new THREE.PointLight(0xd7d6ff,1300,200,2);
        standaLight[2] = new THREE.PointLight(0xffd6d6,1300,200,2);
        standaLight[3] = new THREE.PointLight(0xd7d6ff,1300,200,2);
        standaLight[4] = new THREE.PointLight(0xffd6d6,1300,200,2);
        standaLight[5] = new THREE.PointLight(0xd7d6ff,1300,200,2);

        standaLight[0].position.set(0,10,30);
        standaLight[1].position.set(0,10,-30);
        standaLight[2].position.set(30,10,0);
        standaLight[3].position.set(-30,10,0);
        standaLight[4].position.set(0,35,0);
        standaLight[5].position.set(0,-15,0);

        standaLight.forEach(i => {
          i.castShadow = true;
          this.scene.add(i); //BAD
        })
      };
    };

    startRefGeo = () => {
      const heroGeometry = new THREE.SphereGeometry(0.005, 64, 64);

      const heroMaterialMirror = new THREE.MeshStandardMaterial( {
          color: 0x7C7C7C,
          metalness: 1,
          roughness: 0,
          side: THREE.DoubleSide,
          flatShading: false
      });

      const heroMaterialFlat = new THREE.MeshStandardMaterial( {
        color: 0x7C7C7C,
        metalness: 0,
        roughness: 0.8,
        side: THREE.DoubleSide,
        flatShading: false
      });

      const heroMaterialGlossy = new THREE.MeshStandardMaterial( {
        color: 0x7C7C7C,
        metalness: 0,
        roughness: 0.05,
        side: THREE.DoubleSide,
        flatShading: false
      });

      const heroSphereMirror = new THREE.Mesh(heroGeometry, heroMaterialMirror);
      heroSphereMirror.position.set(0, -0.007, 0);

      const heroSphereFlat = new THREE.Mesh(heroGeometry, heroMaterialFlat);
      heroSphereFlat.position.set(0, -0.007, 0.01);

      const heroSphereGlossy = new THREE.Mesh(heroGeometry, heroMaterialGlossy);
      heroSphereGlossy.position.set(0, -0.007, -0.01);

      this.scene.add(heroSphereMirror, heroSphereFlat, heroSphereGlossy); // BAD
    };

    startCamera = () => {
      const { viewWidth, viewHeight } = this.props;
      this.camera = new THREE.PerspectiveCamera(40, viewWidth / viewHeight, 0.1, 1000); // BAD
      // this.camera = new THREE.PerspectiveCamera(40, viewWidth / viewHeight, 0.001, 1000); // BAD
    };

    startControls = () => {
      const { controlType,
          controlDampeningStatus,
          controlDampeningFactor,
          controlScreenPanning,
        } = this.props.engine;

      if (controlType === 1) {
        this.controls = new OrbitControls(this.camera, this.mount);
        this.controls.enableDamping = controlDampeningStatus;
        this.controls.dampingFactor = controlDampeningFactor;
        this.controls.screenSpacePanning = controlScreenPanning;

        this.controls.update();
      };
    };

    startRenderer = () => {
      const { viewWidth, viewHeight } = this.props;
      const { rendererAAStatus,
              pcLightsStatus,
              toneMappingConfig,
              toneMappingExposure,
              colorSpace
            } = this.props.engine;

      if (rendererAAStatus === 1) {
        this.renderer = new THREE.WebGLRenderer({ antialias: true });
      } else {
        this.renderer = new THREE.WebGLRenderer({});
      };

      this.renderer.setSize(viewWidth, viewHeight);
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.physicallyCorrectLights = pcLightsStatus;
      this.renderer.toneMapping = toneMappingConfig;
      this.renderer.toneMappingExposure = toneMappingExposure;
      this.renderer.outputEncoding = colorSpace;

      this.renderer.setSize(viewWidth, viewHeight);
      this.mount.appendChild(this.renderer.domElement);
    };

    startEnvironment = () => {
        const { environmentStatus } = this.props.engine;
        this.levARpmremGenerator = new THREE.PMREMGenerator(this.renderer);

        if (environmentStatus) {
          new RGBELoader()
          .setDataType(THREE.UnsignedByteType)
          .load(hdrENV, (texture) => {
              var envMap = this.levARpmremGenerator.fromEquirectangular(texture).texture;
              this.levARpmremGenerator.dispose();
              this.scene.environment = envMap;
            }
          );

          this.levARpmremGenerator.compileEquirectangularShader();
        };

        new RGBELoader()
        .setDataType(THREE.UnsignedByteType)
        .load(hdrBKD, (texture) => {
             var bkdMap = this.levARpmremGenerator.fromEquirectangular(texture).texture;
             this.levARpmremGenerator.dispose();
             this.scene.background = bkdMap;
          }
        );
        this.levARpmremGenerator.compileEquirectangularShader();
    };

    startLoader = () => {
      const BUCKET_URL = process.env.REACT_APP_BUCKET_URL_AR;
      const { hash } = this.props;

      const url = `${BUCKET_URL}${hash}.glb`;

      const manager = new THREE.LoadingManager();
      const loader = new GLTFLoader(manager);
      loader.setCrossOrigin('anonymous');

      let loaderContainer = document.createElement("div");
      loaderContainer.setAttribute('class', 'shadeLoading-container');

      let viewLoader = document.createElement('div');
      viewLoader.setAttribute("class", "shadeLoading");

      loaderContainer.append(viewLoader);

      manager.onStart = () => {
        this.mount.appendChild(loaderContainer);
      };

      manager.onLoad = () => {
        this.mount.removeChild(loaderContainer);
        this.props.setShadeReady('SHADE_READY');
      };

      return new Promise((resolve, reject) => {
        loader.load(url, (gltf) => {
          const scene = gltf.scene || gltf.scenes[0];
          this.loadHero(scene);
          resolve(gltf);
        }, undefined, reject);
      });
    };

    loadHero = (object) => {
      this.scene.add(object); // BAD

      this.glbbounding = new THREE.Box3().setFromObject(object);
      this.glbboundingvec = this.glbbounding.getSize(new THREE.Vector3());
      this.glbboundinglength = this.glbboundingvec.length();
      this.glbboundingcenter = this.glbbounding.getCenter(new THREE.Vector3());

      this.startPostProcessing();
      this.updateResize();
      this.renderLoop();
    };

    startPostProcessing = () => {
      const { rendererAAStatus} = this.props.engine;
      const { viewWidth, viewHeight } = this.props;

      if (rendererAAStatus === 1) {
        this.levARcomposer = new EffectComposer(this.renderer);
        this.levARcomposer.addPass(new RenderPass(this.scene, this.camera));
      } else if (rendererAAStatus === 2) {
        this.levARcomposer = new EffectComposer(this.renderer);
        this.levARcomposer.addPass(new RenderPass(this.scene, this.camera));
        this.SMAAPass = new SMAAPass( viewWidth * this.renderer.getPixelRatio(), viewHeight * this.renderer.getPixelRatio() );
        this.levARcomposer.addPass(this.SMAAPass);
      } else if (rendererAAStatus === 3) {
        this.levARcomposer = new EffectComposer(this.renderer);
        this.levARcomposer.addPass(new RenderPass(this.scene, this.camera));
        this.fxaaPass = new ShaderPass( FXAAShader );
        var pixelRatio = this.renderer.getPixelRatio();
        this.fxaaPass.material.uniforms['resolution'].value.x = 1 / ( viewWidth * pixelRatio );
        this.fxaaPass.material.uniforms['resolution'].value.y = 1 / ( viewHeight * pixelRatio );
        this.levARcomposer.addPass(this.fxaaPass);
      } else {
        this.levARcomposer = new EffectComposer(this.renderer);
        this.levARcomposer.addPass(new RenderPass(this.scene, this.camera));
      };

      window.addEventListener('resize', this.updateResizeHandler);
    };

    renderLoop = () => {
        if (this.updateResizeAlarm > 0) this.updateResize();
        this.levARcomposer.render();
        this.requestID = window.requestAnimationFrame(this.renderLoop);
    };

    updateResize = () => {
      const { setWidth, setHeight, viewWidth, viewHeight } = this.props;
      const { rendererAAStatus} = this.props.engine;

      if (rendererAAStatus === 3) {
        var pixelRatio = this.renderer.getPixelRatio();
        this.fxaaPass.material.uniforms['resolution'].value.x = 1 / ( viewWidth * pixelRatio );
        this.fxaaPass.material.uniforms['resolution'].value.y = 1 / ( viewHeight * pixelRatio );
        //comment out the above three lines and maximize a small window to full size with rendererAAStatus 3 for a good example of a shader not getting updated
      };

      setWidth(window.innerWidth);
      setHeight(window.innerHeight);

      if (viewHeight > viewWidth) {
        //I'm Tall screen
        if (this.glbboundingvec.x > this.glbboundingvec.y) {
          if(this.glbboundingvec.y < 0.05){
            if (this.glbboundingvec.x < 0.15 && this.glbboundingvec.z < 0.15){
              this.camera.position.set(0, 0.35, 0.35);
            } else {
            //I'm Flat Asset IE RUG
            //New Rugs Dec 11, 2020 // 0.038
            // rug jcwig4gd // 0.009
            // shoe ugqejree // 0.267
            // mug ee8n5tzq // 0.105
              this.camera.position.set(0, (this.glbboundingvec.y / .01), (this.glbboundingvec.x * 5));
            }
          } else {
            //I'm Fat Asset
            this.camera.position.set(0, this.glbboundingvec.y, (this.glbboundingvec.x * 5));
          }
        } else {
          //I'm Tall Asset
          this.camera.position.set(0, this.glbboundingvec.y, (this.glbboundingvec.y * 3));
        };

      } else {
        //I'm Fat Screen

        if (this.glbboundingvec.x > this.glbboundingvec.y) {

          if(this.glbboundingvec.y < 0.05){
            if (this.glbboundingvec.x < 0.15 && this.glbboundingvec.z < 0.15){
              this.camera.position.set(0, 0.35, 0.35);
            } else {
            //I'm Flat Asset IE RUG
            //New Rugs Dec 11, 2020 // 0.038
            // rug jcwig4gd // 0.009
            // shoe ugqejree // 0.267
            // mug ee8n5tzq // 0.105
            this.camera.position.set(0, (this.glbboundingvec.y / .01), (this.glbboundingvec.x * 2.7));
            }
          } else {
            //I'm Fat Asset IE Everything else
            this.camera.position.set(0, (this.glbboundingvec.y / 1), (this.glbboundingvec.x * 3)); // new
            // this.camera.position.set(0, (this.glbboundingvec.y / 2), (this.glbboundingvec.x * 3)); // old
          }
        } else {
          //I'm Tall Asset
          this.camera.position.set(0, this.glbboundingvec.y, (this.glbboundingvec.y * 3));  // new
          // this.camera.position.set(0, this.glbboundingvec.y, (this.glbboundingvec.y * 3)); // old
        };
      };

      this.controls.target = (this.glbboundingcenter);
      this.camera.lookAt(this.glbboundingcenter);
      this.controls.update();
      this.camera.aspect = viewWidth / viewHeight;
      this.renderer.setSize(viewWidth, viewHeight);
      this.levARcomposer.reset();
      this.camera.updateProjectionMatrix();

      if (this.updateResizeAlarm > 0) this.updateResizeAlarm -= 1;
    };

    render() {
      return (
        <div className="Shade" ref={ref => (this.mount = ref)}/>
      );
    };
};

export const mapStateToProps = state => ({
  loading: state.loading,
  hash: state.hash,
  shadeState: state.shadeState,
  engine: state.engine,
  viewWidth: state.viewWidth,
  viewHeight: state.viewHeight,
});

export const mapDispatchToProps = dispatch => ({
  setLoading: data => dispatch(actions.setLoading(data)),
  setShadeReady: data => dispatch(actions.setShadeReady(data)),
  setWidth: data => dispatch(actions.setWidth(data)),
  setHeight: data => dispatch(actions.setHeight(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Shade);
